import { render, staticRenderFns } from "./contract.vue?vue&type=template&id=96312cee&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/contract_template/contractStyle.css?vue&type=style&index=0&id=96312cee&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96312cee",
  null
  
)

export default component.exports